import { motion } from "framer-motion";
import { Feather, Sun, Flower2 } from "lucide-react";

const CHAPTERS = [
  {
    num: "Chapter I",
    name: "Haya",
    arabic: "حياء",
    meaning: "Life, Modesty & Sacred Grace",
    story:
      "The gentle whisper of dawn — dignity, purity of spirit, and the quiet beauty of a humble heart.",
    Icon: Feather,
  },
  {
    num: "Chapter II",
    name: "Noor",
    arabic: "نور",
    meaning: "Divine Light & Celestial Radiance",
    story:
      "The guiding star that brightens the darkest sky, casting warmth and hope on all who cross her path.",
    Icon: Sun,
  },
  {
    num: "Chapter III",
    name: "Jamal",
    arabic: "جمال",
    meaning: "Elegance & Universal Beauty",
    story:
      "The bloom of an enchanted garden — harmony, poetic grace, and a beauty that time cannot fade.",
    Icon: Flower2,
  },
];

export const Chapters = () => (
  <section id="chapters" className="relative py-28 sm:py-36 px-6" data-testid="chapters-section">
    <div className="max-w-6xl mx-auto">
      <div className="text-center mb-16">
        <motion.p
          initial={{ opacity: 0, y: 18 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8 }}
          className="eyebrow mb-4"
        >
          Chapters of her name
        </motion.p>
        <motion.h2
          initial={{ opacity: 0, y: 18 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, delay: 0.1 }}
          className="font-display text-3xl sm:text-5xl text-amber-100 font-light"
        >
          Three words, one fairytale
        </motion.h2>
      </div>

      <div className="grid md:grid-cols-3 gap-6 lg:gap-10">
        {CHAPTERS.map((ch, i) => (
          <motion.article
            key={ch.name}
            initial={{ opacity: 0, y: 40, rotateX: 16 }}
            whileInView={{ opacity: 1, y: 0, rotateX: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.9, delay: i * 0.18, ease: [0.16, 1, 0.3, 1] }}
            style={{ transformPerspective: 1000 }}
            className="glass-card rounded-3xl p-8 sm:p-10 relative overflow-hidden group"
            data-testid={`chapter-card-${i + 1}`}
          >
            <div className="absolute -top-6 -right-4 font-royal text-[7rem] leading-none text-amber-200/5 select-none">
              {["I", "II", "III"][i]}
            </div>
            <p className="eyebrow">{ch.num}</p>
            <div className="mt-6 flex items-end justify-between">
              <h3 className="font-royal text-4xl gold-text">{ch.name}</h3>
              <span className="font-display text-3xl text-rose-200/70">{ch.arabic}</span>
            </div>
            <div className="mt-4 flex items-center gap-2 text-amber-300/90">
              <ch.Icon size={15} />
              <span className="text-xs tracking-[0.18em] uppercase">{ch.meaning}</span>
            </div>
            <p className="mt-6 text-slate-300/90 font-light leading-relaxed text-sm sm:text-base">{ch.story}</p>
            <div className="mt-8 h-px w-16 bg-gradient-to-r from-amber-300/60 to-transparent group-hover:w-28 transition-[width] duration-500" />
          </motion.article>
        ))}
      </div>
    </div>
  </section>
);
